// CORE
import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';

// COMPONENTS
import {
  AuthSignInComponent,
  AuthBaseComponent,
  AuthForgotComponent,
  AuthRecoverComponent,
  AuthErrorComponent,
} from './components';

const routes :Routes = [
  {
    path: 'error/:type',
    component: AuthErrorComponent,
  },
  {
    path: 'error',
    component: AuthErrorComponent,
  },
  {
    path: '',
    component: AuthBaseComponent,
    children: [
      {
        path: 'login',
        component: AuthSignInComponent,
        data: { returnUrl: window.location.pathname },
      },
      {
        path: 'forgot-password',
        component: AuthForgotComponent,
      },
      {
        path: 'recover',
        component: AuthRecoverComponent,
      },
    ],
  },
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
})
export class AuthRoutingModule {}
